import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import { toast } from "react-toastify";
import kitchenBg from "../../../assets/images/banner-back-1.jpg";
import SectionHeader from "../section/SectionHeader.js";

const Contact = () => {
  const formRef = useRef();
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  const validatePhoneNumber = (phone) => {
    const phonePattern =
      /^(\+1|1)?\s?(\(\d{3}\)|\d{3})[\s\-]?\d{3}[\s\-]?\d{4}$/;
    return phonePattern.test(phone);
  };

  const validateEmail = (email) => {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailPattern.test(email);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const { name, phone, email, subject, message } = formData;

    if (
      !name.trim() ||
      !phone.trim() ||
      !email.trim() ||
      !subject.trim() ||
      !message.trim()
    ) {
      toast.error("All fields are required!", { position: "top-right" });
      return;
    }

    if (!validatePhoneNumber(phone)) {
      toast.error("Please enter a valid Canadian phone number.", {
        position: "top-right",
      });
      return;
    }

    if (!validateEmail(email)) {
      toast.error("Please enter a valid email address.", {
        position: "top-right",
      });
      return;
    }

    emailjs
      .sendForm(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        formRef.current,
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      )
      .then(
        () => {
          toast.success("Success! We’ve received your message and will respond soon.", {
            position: "top-right",
          });
          setFormData({
            name: "",
            phone: "",
            email: "",
            subject: "",
            message: "",
          });
        },
        (error) => {
          toast.error("Something went wrong while sending your message. Give it another shot!", {
            position: "top-right",
          });
        }
      );
  };

  return (
    <div className="container-fluid mb-4 mt-4">
      <SectionHeader title="Contact" backgroundImage={kitchenBg} />

      <div className="container contact-container mt-4">
        <div className="row g-4">
          <div className="col-md-7" data-sal="slide-right" data-sal-duration="2000" data-sal-delay="300">
            <h2 style={{ fontSize: "40px" }} data-sal="slide-left" data-sal-duration="2000" data-sal-delay="600">
              <strong>Get In Touch</strong>
            </h2>
            <p style={{ color: "black", fontWeight: 400 }}>
              Ready to start your renovation project? Contact us today for a
              free quote and consultation.
            </p>

            <form ref={formRef} onSubmit={handleSubmit}>
              <div className="row mb-3">
                <div className="col">
                  <label className="form-label">Name:</label>
                  <input
                    type="text"
                    className="form-control"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Your name"
                    required
                  />
                </div>
                <div className="col">
                  <label className="form-label">Phone number:</label>
                  <input
                    type="tel"
                    className="form-control"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="Phone number"
                    required
                  />
                </div>
              </div>
              <div className="row mb-3">
                <div className="col">
                  <label className="form-label">Email:</label>
                  <input
                    type="email"
                    className="form-control"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Email address"
                    required
                  />
                </div>
                <div className="col">
                  <label className="form-label">Subject:</label>
                  <select
                    name="subject"
                    className="form-select"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select Your Service</option>
                    <option value="Kitchen Renovations">
                      Kitchen Renovations
                    </option>
                    <option value="Bathroom Renovations">
                      Bathroom Renovations
                    </option>
                    <option value="Basement Renovations">
                      Basement Renovations
                    </option>
                    <option value="Home Extensions">Home Extensions</option>
                  </select>
                </div>
              </div>
              <div className="mb-3">
                <label className="form-label">Message:</label>
                <textarea
                  className="form-control"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  rows="3"
                  placeholder="Your message or address"
                  required
                ></textarea>
              </div>

              <button type="submit" className="btn quote-btn btn-war">
                SEND NOW
              </button>
            </form>
          </div>

          <div className="col-md-5"  data-sal="slide-left" data-sal-duration="2000" data-sal-delay="300">
            <div
              className="card map-card"
              style={{
                height: "300px",
                overflow: "hidden",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                borderRadius: "8px",
                border: "1px solid #ddd",
              }}
            >
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d43031270.8771221!2d-135.67074652677977!3d48.83112040414076!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4b0d03d337cc6ad9%3A0x9968b72aa2438fa5!2sCanada!5e0!3m2!1sen!2sin!4v1746601643899!5m2!1sen!2sin"
                style={{ border: 0, width: "100%", height: "100%" }}
                allowFullScreen=""
                loading="lazy"
                title="Location Map"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
